import {
  UiHStack,
  UiIconListChecks,
  UiIconMagnifyingGlassMinus,
  UiSimpleGrid,
  UiSpinner,
  UiStack,
  uiStyles,
  UiText,
} from '@/lib/ui';
import { dynamicColor } from '@/lib/util';
import { type ChartDataset } from 'chart.js';
import type React from 'react';
import { useEffect, useState } from 'react';
import { type useGetListActivatedChartType } from '@/registration/report/Order';
import LineChart from '@/base/Chart/Line';
import { defaultColors } from '@/api/constant/colors';
import BaseSimpleSelectElement, { type Option as SelectElementOption } from '@/base/Form/SimpleSelectElement';
import type { OnChangeValue } from 'chakra-react-select';
import BaseLoadingSpinner from '@/base/Loading/Spinner';

interface TotalCompleteOrdersChartProps {
  selectOptions: Array<{
    label: string
    value: string
  }>
  useGetListActivatedChart: useGetListActivatedChartType
  title: string
  type: string
  // TODO: Add interface replace any to Pagination
  formatPrice?: (amount: number) => string
  eventOptions?: SelectElementOption[]
}
const OrderActivatedChartReport: React.FC<TotalCompleteOrdersChartProps> = ({ selectOptions, useGetListActivatedChart, title, eventOptions = [] }) => {
  const [selectedGroup, setSelectedGroup] = useState<string>('');
  const [labels, setLabels] = useState<string[]>([]);
  const [datasets, setDatasets] = useState<Array<ChartDataset<'line', number[]>>>([]);
  const [eventId, setEventId] = useState<string>('');
  const [totalRegistration, setTotalRegistration] = useState<number>(0);

  const { data, isLoading } = useGetListActivatedChart({ groupName: selectedGroup, eventId });

  useEffect(() => {
    let colors: string[] = [...defaultColors];

    if (data && !data?.errors) {
      setLabels(data.item.labels);
      let totals = 0;
      const fetchDataset = data?.item.datasets.map((item: any) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, no-eval
        totals += eval(item.values.join('+'));
        const color = dynamicColor(colors);
        colors = colors.filter((value) => { return value !== color; });

        return {
          label: item.label,
          data: item.values,
          backgroundColor: color,
          borderColor: color,
        };
      });
      setTotalRegistration(totals);
      setDatasets(fetchDataset);
    }
  }, [data, selectedGroup, title]);

  const handleChange = (option: OnChangeValue<SelectElementOption, false>) => {
    setSelectedGroup(option?.value ? `${option?.value}` : '');
  };

  const handleChangeEvent = (option: OnChangeValue<SelectElementOption, false>) => {
    setEventId(option?.value ? `${option?.value}` : '');
  };

  return (
    <UiStack
      alignItems={'stretch'}
      spacing={4}
      borderWidth={'1px'}
      borderColor={'blackAlpha.100'}
      borderRadius={uiStyles.borderRadius}
      p={8}
    >
      <UiHStack spacing={2}>
        <UiIconListChecks color={'text.primary'} />
        <UiText variant={'body1'}>{title}</UiText>
      </UiHStack>
      <UiSimpleGrid columns={2} spacing={4} flexGrow={1}>
        <UiStack flexGrow={1}>
          <BaseSimpleSelectElement
            optionValue={eventId}
            onChange={handleChangeEvent}
            options={eventOptions}
            placeholder={'Select event'}
          />
        </UiStack>
        <UiStack flexGrow={1}>
          <BaseSimpleSelectElement
            optionValue={selectedGroup}
            onChange={handleChange}
            options={selectOptions}
            placeholder={'Select group'}
          />
        </UiStack>
      </UiSimpleGrid>
      {labels?.length === 0 && (
        <UiHStack py={2}>
          <UiIconMagnifyingGlassMinus color={'text.secondary'} />
          <UiText color={'text.secondary'} variant={'body2'}>
            No results
          </UiText>
        </UiHStack>
      )}

      {labels && labels.length > 0 && (
        <UiStack py={2}>
          <UiStack shadow={'base'} borderRadius={uiStyles.borderRadius} bgColor={'#fff'} p={6}>
            <LineChart datasets={datasets} labels={labels} totalRegistration={totalRegistration} />
          </UiStack>
        </UiStack>
      )}
      {isLoading && !!selectedGroup && !!eventId && (
        <UiStack>
          <BaseLoadingSpinner />
        </UiStack>
      )}

    </UiStack>
  );
};

export default OrderActivatedChartReport;
